
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import EmployerCard from './EmployerCard.vue'
import PageContainer from '~/components/Containers/PageContainer.vue'
import { ContainerOptions } from '~/model'
import SwiperContainer from '~/components/Containers/SwiperContainer.vue'
import { EmployerModel } from '~/model/Employer'

export default defineComponent({
  name: 'EmployerCardsList',
  components: { EmployerCard, PageContainer, SwiperContainer },
  props: {
    containerOptions: {
      type: Object as PropType<ContainerOptions>,
      default: () => ({})
    },
    employerCards: {
      type: Array as PropType<Array<EmployerModel>>,
      required: true
    }
  },
  setup() {
    const desktopSliderOptions = {
      loop: false,
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 10,
      navigationId: 'un-next'
    }

    const tabletSliderOptions = {
      loop: false,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      pagination: true
    }
    return {
      desktopSliderOptions,
      tabletSliderOptions
    }
  }
})
